import script from "./StylesAddedModal.vue?vue&type=script&setup=true&lang=js"
export * from "./StylesAddedModal.vue?vue&type=script&setup=true&lang=js"

import "./StylesAddedModal.vue?vue&type=style&index=0&id=122b96bc&lang=scss&scoped=true"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-122b96bc"]])

export default __exports__